import {
  IconDefinition,
  IconFamily,
} from '@fortawesome/fontawesome-common-types';
import styledIcon, { IconStyles } from './styledIcon';

export const faHourglass = hourglass('classic', 'thin');
export const falHourglass = hourglass('classic', 'light');
export const fatHourglass = hourglass('classic', 'thin');
export const fadHourglass = hourglass('duotone', 'thin');
export const fasHourglass = hourglass('classic', 'solid');
export const farHourglass = hourglass('classic', 'regular');

export default function hourglass(
  family: IconFamily,
  style: IconStyles
): IconDefinition {
  return styledIcon(
    family,
    style,
    'hourglass',
    384, // width
    512, // height
    'f254', // unicode
    [
      [
        'classic',
        'solid',
        'M0 32C0 14.3 14.3 0 32 0L64 0 320 0l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 11c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1l0 11c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L64 512l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-11c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75l0-11C14.3 64 0 49.7 0 32zM96 64l0 11c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9l0-11L96 64zm0 384l192 0 0-11c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9l0 11z',
      ],
      [
        'classic',
        'regular',
        'M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 19c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445l0 19-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-19c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67l0-19 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM192 289.9l81.5 81.5C293 391 304 417.4 304 445l0 19L80 464l0-19c0-27.6 11-54 30.5-73.5L192 289.9zm0-67.9l-81.5-81.5C91 121 80 94.6 80 67l0-19 224 0 0 19c0 27.6-11 54-30.5 73.5L192 222.1z',
      ],
      [
        'classic',
        'light',
        'M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l16 0 0 41.6c0 49.4 22.8 96 61.8 126.3L165.9 256 93.8 312.1C54.8 342.4 32 389.1 32 438.4L32 480l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 288 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-41.6c0-49.4-22.8-96-61.8-126.3L218.1 256l72.2-56.1c39-30.3 61.8-76.9 61.8-126.3L352 32l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L336 0 48 0 16 0zM320 32l0 41.6c0 39.5-18.2 76.8-49.4 101L192 235.7l-78.6-61.1C82.2 150.4 64 113.1 64 73.6L64 32l256 0zM192 276.3l78.6 61.1c31.2 24.2 49.4 61.5 49.4 101l0 41.6L64 480l0-41.6c0-39.5 18.2-76.8 49.4-101L192 276.3z',
      ],
      [
        'classic',
        'thin',
        'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8l24 0 0 55.2c0 48.3 23 93.7 61.8 122.4L178.5 256 93.8 318.4C55 347 32 392.5 32 440.8L32 496 8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8l368 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-24 0 0-55.2c0-48.3-23-93.7-61.8-122.4L205.5 256l84.7-62.4C329 165 352 119.5 352 71.2L352 16l24 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 0zM336 16l0 55.2c0 43.2-20.5 83.9-55.3 109.5L192 246.1l-88.7-65.3C68.5 155.1 48 114.4 48 71.2L48 16l288 0zM192 265.9l88.7 65.3c34.8 25.6 55.3 66.3 55.3 109.5l0 55.2L48 496l0-55.2c0-43.2 20.5-83.9 55.3-109.5L192 265.9z',
      ],
      [
        'duotone',
        'thin',
        [
          'M48 16l0 55.2c0 43.2 20.5 83.9 55.3 109.5L192 246.1l88.7-65.3C315.5 155.1 336 114.4 336 71.2L336 16 48 16zm0 424.8L48 496l288 0 0-55.2c0-43.2-20.5-83.9-55.3-109.5L192 265.9l-88.7 65.3C68.5 356.9 48 397.6 48 440.8z',
          'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8l24 0 0 55.2c0 48.3 23 93.7 61.8 122.4L178.5 256 93.8 318.4C55 347 32 392.5 32 440.8L32 496 8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8l368 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-24 0 0-55.2c0-48.3-23-93.7-61.8-122.4L205.5 256l84.7-62.4C329 165 352 119.5 352 71.2L352 16l24 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 0zM336 16l0 55.2c0 43.2-20.5 83.9-55.3 109.5L192 246.1l-88.7-65.3C68.5 155.1 48 114.4 48 71.2L48 16l288 0zM192 265.9l88.7 65.3c34.8 25.6 55.3 66.3 55.3 109.5l0 55.2L48 496l0-55.2c0-43.2 20.5-83.9 55.3-109.5L192 265.9z',
        ],
      ],
    ]
  );
}
